import { GetAllReviewsParams, ReviewsGetKey } from '../entities';

export const DYNAMIC_REVIEWS_MIN_TEXT_LENGTH = 75;
export const DYNAMIC_REVIEWS_MIN_RATING = 3;
export const DYNAMIC_REVIEWS_LOAD_PAGE_SIZE = 3;
export const DYNAMIC_REVIEWS_INITIAL_AMOUNT = 7;
export const DYNAMIC_REVIEWS_SORT = '-created_at';

export const BUILD_GET_ALL_REVIEWS_PARAMS: GetAllReviewsParams = {
  page: 1,
  perPage: DYNAMIC_REVIEWS_INITIAL_AMOUNT + DYNAMIC_REVIEWS_LOAD_PAGE_SIZE,
  minRating: DYNAMIC_REVIEWS_MIN_RATING,
  minTextLength: DYNAMIC_REVIEWS_MIN_TEXT_LENGTH,
  sort: DYNAMIC_REVIEWS_SORT,
};

export const ALL_REVIEWS_GET_KEY: ReviewsGetKey = (pageIndex: number) => ({
  feature: 'dynamic-reviews',
  page: pageIndex + 1,
  perPage: DYNAMIC_REVIEWS_LOAD_PAGE_SIZE,
  minRating: DYNAMIC_REVIEWS_MIN_RATING,
  minTextLength: DYNAMIC_REVIEWS_MIN_TEXT_LENGTH,
  sort: DYNAMIC_REVIEWS_SORT,
});
